<template>
  <app-modal class="new-liming-material">
    <app-modal-default @close="close">
      <template v-slot:header>
        {{ $ml.get('Create new liming material') }}
      </template>
      <template v-slot:content>

        <form @submit.prevent="onSubmit()">

          <div class="form-group">
            <app-text-input
              v-model="material.MaterialName"
              :label="$ml.get('Material name')"
              required
              maxlength="50"
            />

            <app-text-input
              v-model="material.CCE"
              type="number"
              :label="$ml.get('CCE')"
              max="200"
              :min="min"
              hint="%"
              :info-tip="$ml.get(`Calcium Carbonate Equivalent, measures indirectly the Purity of a liming material`)"
              required
              @input="calculateENV"
            />
            <app-text-input
              v-model="material.MgPer"
              type="number"
              :label="$ml.get('Mg')"
              max="100"
              :min="min"
              hint="%"
              required
            />
            <app-text-input
              v-model="material.CaPer"
              type="number"
              :label="$ml.get('Ca')"
              max="100"
              :min="min"
              hint="%"
              required
            />
            <app-text-input
              v-model="material.ENV"
              type="number"
              :label="$ml.get('ENV')"
              max="200"
              :min="min"
              hint="%"
              :disabled="material.IsNeedCalcENV"
              required
            />
            <app-text-input
              v-model="material.Moisture"
              type="number"
              :label="$ml.get('Moisture')"
              max="100"
              :min="min"
              hint="%"
              required
            />
            <app-text-input
              v-show="material.IsNeedCalcENV"
              v-model="material.Pass60"
              type="number"
              :label="$ml.get('Pass 60')"
              max="100"
              :min="min"
              hint="%"
              :info-tip="$ml.get(`This refers to the particle size distribution of the liming material`)"
              required
              @input="calculateENV"
            />
            <app-text-input
              v-show="material.IsNeedCalcENV"
              v-model="material.Pass6to80"
              type="number"
              :label="$ml.get('Pass 60-80')"
              max="100"
              :min="min"
              hint="%"
              :info-tip="$ml.get(`This refers to the particle size distribution of the liming material`)"
              required
              @input="calculateENV"
            />

          </div>

          <app-checkbox
            v-model="material.IsNeedCalcENV"
            :label="$ml.get('Calculate ENV automatically')"
            :info-tip="$ml.get('Effective Neutralizing Value, used to calculate the actual amount of liming material that has to be applied')"
            @input="calculateENV"
            class="checkbox"
          />

          <app-btn type="submit">{{ $ml.get('Save') }}</app-btn>

        </form>

      </template>
    </app-modal-default>
  </app-modal>

</template>

<script>
import API from '@/api'
export default {
  data() {
    return {
      material: {
        MaterialName: this.$ml.get('Name'),
        IsNeedCalcENV: false,
        CCE: null,
        MgPer: null,
        CaPer: null,
        ENV: null,
        Pass60: null,
        Pass6to80: null,
        Moisture: null,
      }
    }
  },
  props: {
    min: {
      type: Number,
      default: 0
    }
  },
  created() {
    this.material.Pass60 = this.material.Pass6to80 = 0
  },
  methods: {
    calculateENV() {
      if(this.material.IsNeedCalcENV) {
        let pass6to80 = this.material.Pass6to80 / 100;
        let pass60 = this.material.Pass60 / 100;
        let env = this.material.CCE / 100 * (pass6to80 * 0.5 + pass60) * 100;
        this.material.ENV =  env > 0 ? env : 0;
        this.material.ENV = (this.material.ENV).toFixed(2);
      }
    },
    onSubmit() {
      return API.program.createLimingMaterial(this.material)
        .then(res => {
          console.log(res)
          this.$emit('selectMaterial', res.data.data.id);
          this.close();
        })
        .catch(err => {
          console.log(err);
        })
    },
    close() {
      this.$emit('close');
    },
  }
}
</script>

<style lang="scss" scoped>
.checkbox {
  width: -mox-fit-content;
  width: -webkit-fit-content;
  width: fit-content;
}
form {
  .form-group {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-right: -16px;
    margin-left: -16px;
    width: 600px;
    > div {
      flex-basis: calc(50% - 32px);
      margin-right: 16px;
      margin-left: 16px;
      margin-bottom: 24px;
      margin-top: 16px;
    }
  }
  .v-check {
    margin-bottom: 24px;
  }
}
</style>
